import { combineReducers } from '../combineReducers';
import { flowsByIdReducer } from './flowsByIdReducer';

export const flowsReducer = combineReducers({
  byId: flowsByIdReducer,
});
